/* eslint-disable no-unused-vars */
import DeploymentAssetView from '@/components/forms/apps/pma/DeploymentAssetView';
import tenant from '@/services/TenantService';
import { toast } from 'react-toastify';
import ToastMessage from '@/components/toasts/ToastMessage';
import { useEffect, useState } from 'react';

export default function PMAEdit({ deployment, onFinish, onCancel }) {
  const [deploymentObj, setDeploymentObj] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDeployment = async () => {
      try {
        const response = await tenant.get(
          `/deployment/${deployment.insertedId || deployment._id}`,
        );
        setDeploymentObj(response.data);
      } catch (error) {
        toast.error(
          <ToastMessage
            title="Fehler"
            subtitle="Fehler beim Laden der Deployment-Daten"
          />,
        );
      } finally {
        setLoading(false);
      }
    };

    fetchDeployment();
  }, [deployment]);

  const handleSubmit = async (formData) => {
    const { isMaintenanceActive, isSyncingAccepted, startThreshold } = formData;
    const deploymentData = {
      config: {
        ...deploymentObj.config,
        isMaintenanceActive,
        isSyncingAccepted,
        startThreshold: String(startThreshold) || '30',
      },
    };
    try {
      await tenant.put(`/deployment/${deploymentObj._id}`, deploymentData);

      const paymentRequired = false;

      onFinish(paymentRequired);
    } catch (error) {
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle={
            error?.response?.data?.message ||
            'Fehler beim Erstellen der Konfiguration'
          }
        />,
      );
    }
  };

  if (loading) {
    return null;
  }

  return (
    <DeploymentAssetView
      key="deploymentAssetView"
      deployment={deploymentObj}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    />
  );
}
